module.exports = __webpack_public_path__ + "img/T-Form.49971286.png";